import React from "react";
import { approachData } from "../../thirdUtils/constant";

const OurApproach = (props) => {
    const { selectedLanguage, language, secondClass } = props
    const isELSelect = language?.language === 'english'
    const isAlSelect = language?.language === 'arabic'
    return (
        <div className={`third-design-approach-main ${secondClass}`}>
            <div className="third-design-approach-container">
                <div className="third-design-approach-heading-div">
                    <h2 data-aos="fade-right"
                        data-aos-easing="ease-out-cubic"
                        data-aos-delay="100"
                        data-aos-offset="0"
                        data-aos-duration="1500">{selectedLanguage?.txt_our_approach}</h2>
                    <h1>{selectedLanguage?.txt_the_procedure_for_a_check_up}</h1>
                </div>
                <div>
                    <button className="third-design-learn-more-btn">{selectedLanguage?.txt_learn_more}</button>
                </div>
            </div>
            <div className="third-design-approach-data-container">
                {
                    approachData?.map((v, i) => {
                        return (
                            <div>
                                <div className="third-design-approach-serial-no-div">
                                    {v?.sNo}
                                </div>
                                <div className="third-design-approach-data-text-div">
                                    <h2>
                                        {isELSelect ? v?.title : (isAlSelect ? v?.alTitle : v?.glTitle)}
                                    </h2>
                                    <p>
                                        {isELSelect ? v?.text : (isAlSelect ? v?.alText : v?.glText)}
                                    </p>
                                </div>
                            </div>
                        )
                    })
                }
            </div>
        </div>
    )
}

export default OurApproach